import React, { FC, useState } from 'react';

import { CartButton } from 'src/shoppe/elements/CartButton';
import LogIn from 'src/prize/scenes/LogIn';

import Logo from '../../atoms/Logo';
import MobileMenuToggle from '../../atoms/MobileMenuToggle';
import { IPrizeMerchant } from '../../types';
import Links from './molecules/Links';
import Search from './molecules/Search';

import styles from './index.module.sass';

interface CameronSeafoodProps {
  merchant: IPrizeMerchant;
}

const CameronSeafood: FC<CameronSeafoodProps> = ({ merchant }) => {   
  const [ overlayLinks, setOverlayLinks ] = useState( false );

  const handleClickMenuToggle = () => {
    setOverlayLinks(( state ) => !state );
  };

  return (
  <div className={styles.header}>
    <div className={styles.mobile}>
      <MobileMenuToggle isActive={overlayLinks} onClick={handleClickMenuToggle} />
    </div>
    <Logo className={styles.logo} image={merchant.logoImageUrl} link={merchant.domain} name={merchant.name} />
    <Search />
    <Links data={merchant.webLinks} overlay={overlayLinks} />
    <LogIn className={styles.login} />
    <CartButton className={styles.cartButton} />
  </div>
);
}
export default CameronSeafood;
